import { StateCreator } from "zustand"
import { FiltroEntregaRetiradaEnum } from "../pages/RecebedorDePedidos/components/FiltroEntregaRetirada"
import { verificarPrintQRCode } from "../pages/RecebedorDePedidos/functions"
import { imprimirNotaFiscal, imprimirNotaGeral } from "../pages/RecebedorDePedidos/qzConfig"
import { RegistrarLogErro } from "../services/clientefiel"
import {
    AceitarPedido,
    acknowledgmentsingle,
    buscarInformacoesPedido,
    CancelarPedido,
    DespacharPedido,
    EventsPolling,
    FinalizarPedido,
    PrepararPedido,
} from "../services/integracao"
import { StoreType } from "./AppStore"
import useLoadingStore from "./LoadingStore"
import { TabStatusEnum } from "./TabStatusStore"

const statusPedido = (status: number) => {
    switch (status) {
        case 0:
            return "Aguardando aceitação"

        case 1:
        case 2:
            return "Aceito"

        case 3:
        case 6:
            return "Em entrega"

        case 4:
        case -1:
        case -2:
        case -3:
        case -4:
        case -10:
            return "Finalizado"

        default:
            return "Em preparação"
    }
}

export type PedidosStoreType = {
    setState: (state: Partial<PedidosStoreType>) => void

    arrayTodosPedidos: any[]
    pedidosAguardandoAceitacao: any[]
    pedidosAceitos: any[]
    pedidosEmPreparacao: any[]
    pedidosAceitosMaisPreparacao: any[]
    pedidosEmEntrega: any[]
    pedidosFinalizados: any[]

    agrupamentos: any[]

    textoBuscaPedidos: string
    buscarPedidos: (texto: string) => void

    filtroEntregaRetirada: FiltroEntregaRetiradaEnum
    setFiltroEntregaRetirada: (filtro: FiltroEntregaRetiradaEnum) => void

    updatePedidosRecebidos: (response: any) => void

    iniciarBuscaPorPedidos: () => number
    buscarNovosEventos: (Authorization: string) => void
    tratarNovosEventos: (eventos: any[]) => void

    removerPedidoListaAnterior: (pedido: any) => void
    adicionarPedidoNovaLista: (pedido: any) => void

    aceitarPedido: (pedido: any, imprimir?: boolean) => Promise<void>
    prepararPedido: (pedido: any, imprimir?: boolean) => Promise<void>
    despacharPedido: (pedido: any) => Promise<void>
    retirarPedido: (pedido: any) => Promise<void>
    finalizarPedido: (pedido: any) => Promise<void>
    cancelarPedido: (
        pedido: any,
        justificativa: string,
        motivoCancelamentoPedido: string
    ) => Promise<any>

    aceitarPedidosAutomaticos: (pedidos: any[]) => void
    prepararPedidosAutomaticos: (pedidos: any[]) => void
}

const createPedidosStore: StateCreator<StoreType, [], [], PedidosStoreType> = (set, get) => ({
    setState: state => set(state),

    arrayTodosPedidos: [],
    pedidosAguardandoAceitacao: [],
    pedidosAceitos: [],
    pedidosEmPreparacao: [],
    pedidosAceitosMaisPreparacao: [],
    pedidosEmEntrega: [],
    pedidosFinalizados: [],

    agrupamentos: [],

    textoBuscaPedidos: "",
    buscarPedidos: (texto: string) => set({ textoBuscaPedidos: texto }),

    filtroEntregaRetirada: FiltroEntregaRetiradaEnum.TODOS,
    setFiltroEntregaRetirada: (filtro: FiltroEntregaRetiradaEnum) =>
        set({ filtroEntregaRetirada: filtro }),

    updatePedidosRecebidos: response => {
        if (typeof response.data === "string") return

        set({ arrayTodosPedidos: response.data })

        const pedidosAguardandoAceitacao = [] as any[]
        const pedidosAceitos = [] as any[]
        const pedidosEmPreparacao = [] as any[]
        const pedidosEmEntrega = [] as any[]
        const pedidosFinalizados = [] as any[]

        const agrupamentos = response.data.reduce((acc: any, p: any) => {
            if (p.quantidadeRegistrosAgrupamento <= 1) return acc
            if (acc.find((a: string) => a === p.agrupamento)) return acc

            acc.push(p.agrupamento)

            return acc
        }, [])

        response.data.forEach((pedido: any) => {
            switch (statusPedido(pedido.status)) {
                case "Aguardando aceitação":
                    pedidosAguardandoAceitacao.push(pedido)

                    if (get().configuracoes!.recebedor.prepararPedidoAutomatico) {
                        get().prepararPedido(pedido)
                        get().ativarAviso()
                    } else if (get().configuracoes!.recebedor.aceitarPedidoAutomatico) {
                        get().aceitarPedido(pedido)
                        get().ativarAviso()
                    }

                    break
                case "Aceito":
                    pedidosAceitos.push(pedido)

                    if (get().configuracoes!.recebedor.prepararPedidoAutomatico) {
                        get().prepararPedido(pedido)
                        get().ativarAviso()
                    }

                    break
                case "Em preparação":
                    pedidosEmPreparacao.push(pedido)
                    break
                case "Em entrega":
                    pedidosEmEntrega.push(pedido)
                    break
                case "Finalizado":
                    pedidosFinalizados.push(pedido)
                    break
            }
        })

        const pedidosAceitosMaisPreparacao = pedidosAceitos
            .concat(pedidosEmPreparacao)
            .sort((a, b) => b.id - a.id)

        if (pedidosAguardandoAceitacao.length > 0) get().ativarAviso()

        set({
            pedidosAguardandoAceitacao,
            pedidosAceitos,
            pedidosEmPreparacao,
            pedidosAceitosMaisPreparacao,
            pedidosEmEntrega,
            pedidosFinalizados,
            agrupamentos,
        })
    },
    iniciarBuscaPorPedidos: () => setInterval(get().buscarNovosEventos, 5000),
    buscarNovosEventos: async Authorization => {
        try {
            const response = await EventsPolling(Authorization)

            if (response.codErro) {
                console.error(response)
                RegistrarLogErro(response.mensagem, "buscarNovosEventos")
                return
            }

            const allFila = []

            for (let j = 0; j < response.length; j++) {
                const acknowledgmentResponse = await acknowledgmentsingle(
                    response[j],
                    Authorization
                )

                if (acknowledgmentResponse.codErro > 0) {
                    RegistrarLogErro(
                        response,
                        "acknowledgmentsingle-buscarNovosPedidosNovo",
                        response[j]
                    )

                    continue
                }

                allFila.push(response[j])
            }

            if (allFila.length > 0) {
                get().tratarNovosEventos(allFila)
            }
        } catch (error) {
            RegistrarLogErro(error, "buscarNovosPedidosNovo")
            console.error(error)
        }
    },
    tratarNovosEventos: async eventos => {
        const novosPedidos: any[] = []
        const filaPrint = []

        const configuracoes = get().configuracoes
        const autorizacao = localStorage.getItem("chaveSistema")

        eventos.forEach(evento => {
            if (evento.code.match(/PRINT(\d?)/)) {
                if (evento.exigirConfirmacao) {
                    filaPrint.push(evento.texto)
                    return
                }

                get().mandarImprimir({
                    pedido: evento,
                    texto: evento.texto,
                    qtd: 1,
                    qrcode: verificarPrintQRCode(evento),
                    QZObrigatorio: true,
                    numeroDaImpressora: evento.code.match(/PRINT(\d)/)
                        ? Number(evento.code.replace(/PRINT(\d)/, "$1"))
                        : 0,
                })

                return
            }

            switch (evento.code) {
                case "PLACED":
                    novosPedidos.push(evento)
                    break
                case "UPDATE":
                    break
                case "CUPOM_FISCAL":
                    if (evento.texto?.includes("Cupom Cancelado"))
                        imprimirNotaGeral({
                            texto: evento.texto + "\n\n\n\n\n",
                            printer: configuracoes!.printer,
                            impressora: configuracoes!.printer.impressoras[0],
                        })
                    else imprimirNotaFiscal(evento.correlationId)
                    break
            }
        })

        if (novosPedidos.length > 0) {
            try {
                const pedidosParaAceitar = [...get().pedidosAguardandoAceitacao]

                for (const pedido of novosPedidos) {
                    if (pedidosParaAceitar.find(p => p.id === pedido.correlationId)) continue

                    const retorno = await buscarInformacoesPedido(autorizacao, pedido.correlationId)

                    if (!retorno?.id) continue

                    if (
                        !get().pedidosAceitos.find(p => p.id === pedido.correlationId) &&
                        retorno.status >= 0
                    ) {
                        pedidosParaAceitar.push(retorno)
                    }
                }

                if (pedidosParaAceitar.length > 0) get().ativarAviso()
                else get().desativarAviso()

                if (get().configuracoes!.recebedor.prepararPedidoAutomatico)
                    get().prepararPedidosAutomaticos(pedidosParaAceitar)
                else if (get().configuracoes!.recebedor.aceitarPedidoAutomatico)
                    get().aceitarPedidosAutomaticos(pedidosParaAceitar)
                else set({ pedidosAguardandoAceitacao: pedidosParaAceitar })
            } catch (error) {
                console.error(error)
                RegistrarLogErro(error, "realizarPlaced", novosPedidos as unknown as string)
            }
        }
    },
    removerPedidoListaAnterior: pedido => {
        try {
            switch (statusPedido(pedido.status)) {
                case "Aguardando aceitação":
                    set(prev => ({
                        pedidosAguardandoAceitacao: prev.pedidosAguardandoAceitacao.filter(
                            p => p.id !== pedido.id
                        ),
                    }))
                    break
                case "Aceito":
                    set(prev => ({
                        pedidosAceitos: prev.pedidosAceitos.filter(p => p.id !== pedido.id),
                        pedidosAceitosMaisPreparacao: prev.pedidosAceitosMaisPreparacao.filter(
                            p => p.id !== pedido.id
                        ),
                    }))
                    break
                case "Em preparação":
                    set(prev => ({
                        pedidosEmPreparacao: prev.pedidosEmPreparacao.filter(
                            p => p.id !== pedido.id
                        ),
                        pedidosAceitosMaisPreparacao: prev.pedidosAceitosMaisPreparacao.filter(
                            p => p.id !== pedido.id
                        ),
                    }))
                    break
                case "Em entrega":
                    set(prev => ({
                        pedidosEmEntrega: prev.pedidosEmEntrega.filter(p => p.id !== pedido.id),
                    }))
                    break
                case "Finalizado":
                    set(prev => ({
                        pedidosFinalizados: prev.pedidosFinalizados.filter(p => p.id !== pedido.id),
                    }))
                    break
            }
        } catch (error) {
            console.error(error)
            RegistrarLogErro(error, "removerPedidoListaAnterior", pedido)
        }
    },
    adicionarPedidoNovaLista: async pedido => {
        switch (statusPedido(pedido.status)) {
            case "Aceito":
                set(prev => ({
                    pedidosAceitos: [pedido, ...prev.pedidosAceitos],
                    pedidosAceitosMaisPreparacao: [pedido, ...prev.pedidosAceitosMaisPreparacao],
                }))
                break

            case "Em preparação":
                // TODO: Checar se precisa
                pedido.status = 7

                set(prev => ({
                    pedidosEmPreparacao: [pedido, ...prev.pedidosEmPreparacao],
                    pedidosAceitosMaisPreparacao: [pedido, ...prev.pedidosAceitosMaisPreparacao],
                }))
                break

            case "Em entrega":
                set(prev => ({ pedidosEmEntrega: [pedido, ...prev.pedidosEmEntrega] }))

                break

            case "Finalizado":
                set(prev => ({ pedidosFinalizados: [pedido, ...prev.pedidosFinalizados] }))

                break
        }
    },
    aceitarPedido: async (pedido, imprimir = true) => {
        if (get().tabStatus === TabStatusEnum.VIEW) {
            console.log("aceitarPedido não realizado por conta de tabStatus VIEW")
            return
        }

        useLoadingStore.getState().setLoading(true)

        try {
            const response = await AceitarPedido(pedido.id)

            get().removerPedidoListaAnterior(pedido)
            get().adicionarPedidoNovaLista(response)

            if (imprimir && get().tipoPainelImpressao() === "plugin") {
                if (
                    localStorage.getItem("ultimoImprimir") !== pedido.id &&
                    pedido.imprimir !== false
                ) {
                    localStorage.setItem("ultimoImprimir", pedido.id)

                    if (
                        get().configuracoes!.printer.imprimirComandasIfood === false &&
                        pedido.plataforma === "ifood_integracao"
                    )
                        return

                    if (
                        get().configuracoes!.printer.imprimir99automatico === false &&
                        !!pedido.didiOrderUUID
                    )
                        return

                    if (
                        get().configuracoes?.printer.tipoImpressao === "navegador" &&
                        !get().configuracoes?.recebedor.imprimirPedidoAutomatico
                    )
                        return

                    if (!get().imprimiuRecentemente(pedido.id))
                        get().mandarImprimir({
                            pedido: pedido,
                            texto: pedido.texto,
                            qtd: get().configuracoes!.user!.parametros.viasImpressao,
                            qrcode: verificarPrintQRCode(pedido),
                        })
                }
            }
        } catch (error) {
            RegistrarLogErro(error, "aceitarPedido", { pedido: pedido } as unknown as string)
        } finally {
            useLoadingStore.getState().setLoading(false)
        }
    },
    prepararPedido: async (pedido, imprimir = true) => {
        if (get().tabStatus === TabStatusEnum.VIEW) {
            console.log("prepararPedido não realizado por conta de tabStatus VIEW")
            return
        }

        useLoadingStore.getState().setLoading(true)

        try {
            const response = await PrepararPedido(pedido.id)

            get().removerPedidoListaAnterior(pedido)
            get().adicionarPedidoNovaLista(response)

            if (imprimir && get().tipoPainelImpressao() === "plugin") {
                if (
                    localStorage.getItem("ultimoImprimir") !== pedido.id &&
                    pedido.imprimir !== false
                ) {
                    localStorage.setItem("ultimoImprimir", pedido.id)

                    if (
                        get().configuracoes!.printer.imprimirComandasIfood === false &&
                        pedido.plataforma === "ifood_integracao"
                    )
                        return

                    if (
                        get().configuracoes!.printer.imprimir99automatico === false &&
                        !!pedido.didiOrderUUID
                    )
                        return

                    if (
                        get().configuracoes?.recebedor.prepararPedidoAutomatico &&
                        !get().imprimiuRecentemente(pedido.id)
                    )
                        get().mandarImprimir({
                            pedido: pedido,
                            texto: pedido.texto,
                            qtd: get().configuracoes!.user!.parametros.viasImpressao,
                            qrcode: verificarPrintQRCode(pedido),
                        })
                }
            }
        } catch (error) {
            RegistrarLogErro(error, "prepararPedido", { pedido: pedido } as unknown as string)
        } finally {
            useLoadingStore.getState().setLoading(false)
        }
    },
    despacharPedido: async pedido => {
        useLoadingStore.getState().setLoading(true)

        try {
            const response = await DespacharPedido(pedido.id)

            get().removerPedidoListaAnterior(pedido)
            get().adicionarPedidoNovaLista(response)
        } catch (error) {
            RegistrarLogErro(error, "despacharPedido", { pedido: pedido } as unknown as string)
        } finally {
            useLoadingStore.getState().setLoading(false)
        }
    },
    // TODO: Apagar e usar "despacharPedido"?
    retirarPedido: async pedido => {
        useLoadingStore.getState().setLoading(true)

        try {
            const response = await DespacharPedido(pedido.id)

            get().removerPedidoListaAnterior(pedido)
            get().adicionarPedidoNovaLista(response)
        } catch (error) {
            RegistrarLogErro(error, "prontoRetirada", { pedido: pedido } as unknown as string)
        } finally {
            useLoadingStore.getState().setLoading(false)
        }
    },
    finalizarPedido: async pedido => {
        useLoadingStore.getState().setLoading(true)

        try {
            const response = await FinalizarPedido(pedido.id)

            get().removerPedidoListaAnterior(pedido)
            get().adicionarPedidoNovaLista(response)
        } catch (error) {
            RegistrarLogErro(error, "finalizarPedido", { pedido: pedido } as unknown as string)
        } finally {
            useLoadingStore.getState().setLoading(false)
        }
    },
    cancelarPedido: async (pedido, observacao, motivoCancelamentoPedido) => {
        if (get().tabStatus === TabStatusEnum.VIEW) {
            console.log("cancelarPedido não realizado por conta de tabStatus VIEW")
            return
        }

        useLoadingStore.getState().setLoading(true)

        const data = {
            observacao,
            motivoCancelamentoPedido,
        }

        let response = undefined

        try {
            response = await CancelarPedido(pedido.id, data)

            get().removerPedidoListaAnterior(pedido)
            get().adicionarPedidoNovaLista(response)
        } catch (error) {
            RegistrarLogErro(error, "cancelarPedido", { pedido: pedido } as unknown as string)
        } finally {
            useLoadingStore.getState().setLoading(false)

            return response
        }
    },
    aceitarPedidosAutomaticos: async (arrayPedidos: any[]) => {
        if (get().tabStatus === TabStatusEnum.VIEW) {
            console.log("aceitarPedidosAutomaticos não realizado por conta de tabStatus VIEW")
            return
        }

        if (!arrayPedidos.length) return

        try {
            for (let i = 0; i < arrayPedidos.length; i++) {
                const pedido = arrayPedidos[i]

                if (pedido.status === 0) {
                    get().aceitarPedido(pedido)
                }
            }
        } catch (error) {
            RegistrarLogErro(error, "aceitarPedidosAutomaticos", arrayPedidos as unknown as string)
        }
    },
    prepararPedidosAutomaticos: async (arrayPedidos: any[]) => {
        if (get().tabStatus === TabStatusEnum.VIEW) {
            console.log("prepararPedidosAutomaticos não realizado por conta de tabStatus VIEW")
            return
        }

        if (!arrayPedidos.length) return

        try {
            for (let i = 0; i < arrayPedidos.length; i++) {
                const pedido = arrayPedidos[i]
                if (pedido.status >= 0 && pedido.status <= 2) {
                    get().prepararPedido(pedido)
                }
            }
        } catch (error) {
            RegistrarLogErro(error, "prepararPedidosAutomaticos", arrayPedidos as unknown as string)
        }
    },
})

export default createPedidosStore
